/**
 * Componente de mensaje individual del chat
 */

import { ChatMessage as ChatMessageType } from '../../types';
import './ChatMessage.css';

interface ChatMessageProps {
  message: ChatMessageType;
  onClick?: (message: ChatMessageType) => void;
  onCopy?: (message: ChatMessageType) => void;
}

export function ChatMessage({ message, onClick, onCopy }: ChatMessageProps) {
  const isUser = message.role === 'user';
  const isAssistant = message.role === 'assistant';
  
  // Asegurar que siempre haya contenido para mostrar (incluso si está vacío, mostrar espacio)
  const displayContent = message.content || '';

  // Determinar si la burbuja es clickeable (tiene audio o es para copiar)
  const isClickable = (isAssistant && message.audioUrl) || onClick || onCopy;

  const handleClick = () => {
    if (onClick) {
      onClick(message);
    }
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    // Click derecho para copiar
    if (onCopy) {
      e.preventDefault();
      onCopy(message);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Ctrl+C o Cmd+C para copiar
    if ((e.ctrlKey || e.metaKey) && e.key === 'c' && onCopy) {
      e.preventDefault();
      onCopy(message);
    }
  };

  return (
    <div className={`chat-message ${isUser ? 'user' : 'assistant'}`}>
      <div 
        className={`message-bubble ${isUser ? 'user-bubble' : 'assistant-bubble'} ${isClickable ? 'clickable' : ''}`}
        onClick={handleClick}
        onContextMenu={handleContextMenu}
        onKeyDown={handleKeyDown}
        tabIndex={isClickable ? 0 : -1}
        role={isClickable ? "button" : undefined}
        aria-label={isAssistant && message.audioUrl ? 'Mensaje con audio. Click para reproducir, Ctrl+C para copiar' : isClickable ? 'Mensaje. Click derecho o Ctrl+C para copiar' : ''}
        title={isAssistant && message.audioUrl ? 'Click para reproducir audio | Ctrl+C para copiar' : isClickable ? 'Click derecho o Ctrl+C para copiar' : ''}
      >
        <p className="message-text">{displayContent}</p>
        {isAssistant && message.audioUrl && (
          <span className="audio-indicator" aria-label="Tiene audio">🔊</span>
        )}
      </div>
    </div>
  );
}


